/* eslint-disable */
// @ts-nocheck

import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

export function generatePDF() {
  const container = document.createElement('div');
  container.className = 'absolute -top-[999rem] -left-[999rem] w-[1200px]';
  container.className = 'pdf absolute z-[999] top-0 left-0 w-[1200px]';
  const pdfmount = document.getElementById('pdf-mount');
  pdfmount.appendChild(container);

  const pages = [...document.querySelectorAll('[data-pdf-page]')];
  const _pages = {};

  let count = 0;

  for (let index = 0; index < pages.length; index++) {
    const page = pages[index];
    const clone = page.cloneNode(true);

    const pageLists = clone.querySelectorAll('.results-pillar-text-column li');

    for (const li of pageLists) {
      if (!li.classList.contains('processed')) {
        li.classList.add('processed');

        li.innerHTML = `<div class="pdf-li-bullet">&bull;</div><div class="inline-block w-full">${li.innerHTML}</div>`;
      }
    }

    if (index === 0) {
      const canvas = page.querySelector('[data-canvas-main]');
      const _canvas = clone.querySelector('[data-canvas-main]');
      _canvas.parentElement.innerHTML = `<img class="blur-[1px] absolute inset-0 block w-full h-full object-center object-contain" src="${canvas.toDataURL()}" />`;
    }

    container.appendChild(clone);
    _pages[index] = {
      clone,
    };

    (function (index) {
      html2canvas(clone, {
        scale: 1.25,
      }).then(function (canvas) {
        const image = new Image();
        image.src = canvas.toDataURL('image/jpeg', 0.375);
        container.appendChild(image);
        const imageWidth = 210;
        const imageHeight = imageWidth * (canvas.height / canvas.width);
        const { left, top, width, height } = clone.getBoundingClientRect();
        const links = [...clone.querySelectorAll('a')];
        const _links = [];

        for (const link of links) {
          const {
            left: linkLeft,
            top: linkTop,
            width: linkWidth,
            height: linkHeight,
          } = link.getBoundingClientRect();
          const url = link.getAttribute('href');
          const _x = ((linkLeft - left) / width) * imageWidth;
          const _y = ((linkTop - top) / height) * imageHeight;
          const _w = (linkWidth / width) * imageWidth;
          const _h = (linkHeight / height) * imageHeight;
          _links.push({
            _x,
            _y,
            _w,
            _h,
            url,
          });
        }

        _pages[index] = {
          ..._pages[index],
          image,
          imageWidth,
          imageHeight,
          _links,
        };

        container.removeChild(_pages[index].clone);
        delete _pages[index].clone;

        count++;

        if (count === pages.length) {
          const doc = new jsPDF({
            precision: 10,
          });

          for (const index of Object.keys(_pages)
            .sort()
            .map((index) => parseInt(index))) {
            doc.setFillColor(36, 33, 73);
            if (index > 1) {
              doc.addPage();
            }

            const { image, imageWidth, imageHeight, _links } = _pages[index];
            doc.addImage(
              image.src,
              null,
              0,
              index === 1 ? _pages[index - 1].imageHeight : 0,
              imageWidth,
              imageHeight,
              null,
              'FAST'
            );
            container.removeChild(_pages[index].image);
            delete _pages[index].image;

            for (const link of _links) {
              const { _x, _y, _w, _h, url } = link;
              doc.link(_x, _y, _w, _h, { url });
            }
          }

          const pdfBlob = doc.output('blob');
          const pdfUrl = URL.createObjectURL(pdfBlob);
          const link = document.createElement('a');
          link.href = pdfUrl;
          link.download = 'results.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(pdfUrl);
        }
      });
    })(index);
  }
}
